import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "animate.css";
import { Fragment, useEffect, useState } from "react";
import { getAuth } from "./redux/features/authSlice";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";
import {
  Dashboard,
  DashboardLanding,
  FlagCount,
  FlagQuerry,
  Login,
  NotFound,
  PrivateRoute,
  ReportStepOne
} from "./pages/pageListAsync";
function App() {
  const [data, setData] = useState({ sideBarLinks: [] });
  useEffect(() => {
    import("./utils/constants").then(({ sideBarLinks }) => {
      setData({ sideBarLinks });
    });
  }, []);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    const handleLogOut = async () => {
      try {
        Cookies.remove("accessToken");
        Cookies.remove("testnetaccessToken");
        navigate("/");
        toast.success(
          "Your session has expired. Please log in again to continue"
        );
      } catch (err) {
        toast.error(err.message);
      }
    };

    const setAuth = async () => {
      try {
        const result = dispatch(getAuth());
        if (result?.payload?.response?.data?.message === "Unauthorized") {
          await handleLogOut();
        }
      } catch (error) {
        console.error(error);
      }
    };
    if (Cookies.get(`${process.env.REACT_APP_NETWORK}accessToken`) === "true") {
      setAuth();
    }
  }, [dispatch, navigate]);

  useEffect(() => {
    const cookeiData = Cookies.get(
      `${process.env.REACT_APP_NETWORK}accessToken`
    );
    if (!cookeiData) {
      navigate("/");
    }
  }, [navigate]);
  return (
    <>
      <ToastContainer autoClose={2000} />
      <Routes>
        <Route exact path="/" element={<Login />} />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        >
          <Route index path="dashboard" element={<DashboardLanding />}></Route>
          <Route
            path="report-first/:nodeId/:date"
            element={<ReportStepOne />}
          ></Route>
          <Route
            path="flag-users/flags/:userId"
            element={<FlagCount />}
          ></Route>
          <Route
            path="flag-users/flags/query/:flagId"
            element={<FlagQuerry />}
          ></Route>

          {/* {sideBarLinks.map(
            (item, index) =>
              item.title !== "Dashboard" && (
                <Route
                  key={index}
                  path={item.path}
                  element={<Fragment>{item.component}</Fragment>}
                ></Route>
              )
          )} */}
          {data?.sideBarLinks.map((item, index) => {
            if (item.component === null && item.child) {
              return item.child.map((childItem, childIndex) => (
                <Route
                  key={`${index}-${childIndex}`}
                  path={childItem.path}
                  element={<Fragment>{childItem.component}</Fragment>}
                />
              ));
            } else if (item.title !== "Dashboard") {
              // Render routes for other items except "Dashboard"
              return (
                <Route
                  key={index}
                  path={item.path}
                  element={<Fragment>{item.component}</Fragment>}
                />
              );
            }
            return null;
          })}

          <Route path="*" element={<NotFound />}></Route>
        </Route>
      </Routes>
    </>
  );
}

export default App;
